import React from "react"
import { css } from "@jsUtils"

import IconDownload from "@assets/svg/icon-download.svg"

// import Circle from "../Circle"

import Styles from "./actionlink.module.scss"

/**
 * Create a link to a file or other external, with optional new window/tab
 * @param {object} props - react props
 * @todo: add Cirlce component
 */
const ActionLink = ({ download, linkTarget, targetWindow, text, extraClass }) => {
  return (
    <a className={css(Styles.actionLink, extraClass)} href={linkTarget} target={targetWindow}>
      <span className={Styles.text}>{text}</span>
      {download && <IconDownload />}
      {/* <Circle color={color} content={action} /> */}
    </a>
  )
}

export default ActionLink
